import type { ReactNode } from 'react';
import styles from './KpiCard.module.css';

export type KpiTone = 'navy' | 'blue' | 'amber' | 'red' | 'green';

interface IKpiCardIconProps {
  icon: { glyph: string; tone: KpiTone };
  value: ReactNode;
  label: string;
  sub?: string;
  valueTone?: never;
  children?: never;
}

interface IKpiCardCenteredProps {
  icon?: never;
  value: ReactNode;
  label: string;
  sub?: never;
  valueTone: KpiTone;
  children?: ReactNode;
}

type IKpiCardProps = IKpiCardIconProps | IKpiCardCenteredProps;

export function KpiCard(props: IKpiCardProps) {
  if (props.icon) {
    return (
      <div className={styles.card}>
        <span
          className={`${styles.icon} ${styles[`tone_${props.icon.tone}`]}`}
          aria-hidden="true"
        >
          {props.icon.glyph}
        </span>
        <div className={styles.text}>
          <span className={styles.value}>{props.value}</span>
          <span className={styles.label}>{props.label}</span>
          {props.sub ? <span className={styles.sub}>{props.sub}</span> : null}
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles.card} ${styles.centered}`}>
      <span className={`${styles.valueCentered} ${styles[`valueTone_${props.valueTone}`]}`}>
        {props.value}
      </span>
      <span className={styles.labelCentered}>{props.label}</span>
      {props.children}
    </div>
  );
}
